export default __webpack_public_path__ + "static/present-ad555b2d43fd851ec28df85e0729ebbc.svg";